import React, { PropsWithChildren } from "react";
import { Button, Tooltip } from "@chakra-ui/react";
import useConfirmation from "hooks/useConfirmation";

interface ButtonWithConfirmProps extends PropsWithChildren {
  header: string;
  subHeader?: string | JSX.Element;
  body: string | JSX.Element;
  handleConfirm: () => void;
  confirmButtonText: string;
  buttonText?: string;
  intent?: "warning" | "confirmation";
  isDisabled?: boolean;
  buttonProps?: object;
  tooltipLabel?: string;
}

export default function ButtonWithConfirm({
  buttonText = "",
  header,
  body,
  subHeader,
  handleConfirm,
  confirmButtonText,
  intent = "warning",
  isDisabled = false,
  children,
  buttonProps = {},
  tooltipLabel = undefined,
}: ButtonWithConfirmProps) {
  const { confirm, ConfirmationDialog } = useConfirmation();

  const intentStyling = intent === "warning" ? { colorScheme: "red", variant: "outline" } : { colorScheme: "brand" };

  const handleClick = () => {
    confirm({ header, subHeader, body, confirmButtonText, intent, onConfirm: handleConfirm });
  };

  const button = () => (children ? (
    React.cloneElement(children as JSX.Element, { onClick: handleClick, ...(isDisabled ? { isDisabled: true } : {}) })
  ) : (
    <Button {...intentStyling} onClick={handleClick} {...(isDisabled ? { isDisabled: true } : {})} {...buttonProps}>
      {buttonText}
    </Button>
  ));

  return (
    <>
      {
        tooltipLabel ? (
          <Tooltip label={tooltipLabel} placement="top">
            {button()}
          </Tooltip>
        ) : (
          button()
        )
      }
      <ConfirmationDialog />
    </>
  );
}
